/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ItemWithRelations } from '../../models/item-with-relations';

export interface AdminGetInventoryItems$Params {
  inventoryId: string;
  includeRemoved?: boolean;
}

export function adminGetInventoryItems(http: HttpClient, rootUrl: string, params: AdminGetInventoryItems$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ItemWithRelations>>> {
  const rb = new RequestBuilder(rootUrl, adminGetInventoryItems.PATH, 'get');
  if (params) {
    rb.query('inventoryId', params.inventoryId, {});
    rb.query('includeRemoved', params.includeRemoved, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ItemWithRelations>>;
    })
  );
}

adminGetInventoryItems.PATH = '/admin/inventory/items';
